import React, { Component } from 'react';
import '../../App.css';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import calculatePrice from '../../util/calculatePrice';
import classname from 'classnames';
import {getUserSession} from '../../actions/user';
import { logout } from '../../actions/user';

class TopNav extends Component{
  constructor(props) {
    super(props);
    this.getUserSession();
    this.state = { navClass:  "collapse navbar-collapse"} ;
  }
  getUserSession(){
    console.log('getting user session');
    this.props.dispatch(getUserSession());
  }
  toggleNav() {
    var navClass = "collapse navbar-collapse in";
    if(this.state.navClass.indexOf(' in') > 0) {
      navClass = "collapse navbar-collapse";
    }
    this.setState({navClass: navClass});
  }
  Logout(){
    this.props.dispatch(logout());
    this.props.dispatch(
      logout(() => {
          this.props.history.push('/')
      })
    )
  }
  render() {
    var active_Next = classname({
      'button': true,
      'next'  : true,
      'inactive-next': !(this.props.User.loggedin)
    });
    var targetAttrib = "_self";
    if(this.props && this.props.inSteps) {
      targetAttrib = "linkFromSteps";
    }
    return (
      <div>
        <header className="header">
          <div className="container">
            <div className="row">
              <nav className="navbar ">
                <div className="container-fluid">
                  <div className="navbar-header">
                    <a className="navbar-brand" href="https://proofreadingmanuscripts.com/" target={targetAttrib}><img src="/checkout_files/logo.png" className="logo" alt="Edit_My_Paper_logo" /></a>
                    <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#myNavbar" onClick={this.toggleNav.bind(this)}>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                    </button>
                  </div>
                  <div className={this.state.navClass}>
                    <ul className="nav navbar-nav">
                      <li className="active"><a href="/get-started">Submit Your Paper</a></li>
                      <li><a href="https://proofreadingmanuscripts.com/guarantee/" target={targetAttrib}>Guarantee</a></li>
                      <li><a href="https://proofreadingmanuscripts.com/faq/" target={targetAttrib}>FAQ</a></li>
                      <li><a href="https://proofreadingmanuscripts.com/examples/" target={targetAttrib}>Examples</a></li>
                      {(this.props.User.role === "student") && <li><Link to="/studentdashboard" target={targetAttrib}>My Account</Link></li>}
                      {(this.props.User.role === "editor") && <li><Link to="/editordashboard">Dashboard</Link></li>}
                      {(this.props.User.role === "admin") && <li><Link to="/admindashboard">Admin Dashboard</Link></li>}
                      {this.props.User.loggedin && <li><a href="https://proofreadingmanuscripts.com/" onClick={this.Logout.bind(this)}>Logout</a></li>}
                      {!this.props.User.loggedin && <li><Link to="/login">Login</Link></li>}
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </header>
        </div>
      )
    }
}

export default connect(
  ({User, Dashboard})=>({User, Dashboard})
)(TopNav);

// {!this.props.User.loggedin && <li><Link to="/register">Register</Link></li>}



// WEBPACK FOOTER //
// ./src/components/includes/TopNav.js